import { authDefaultState } from '@slices/auth';
import { projectsDefaultState } from '@slices/projects';

import { findById, first } from '@helpers/data';
import {
  getCurrentProjectAdminApiUrlById,
  getCurrentProjectWebApiUrlById,
} from '@helpers/projects';

import { readAuthData } from '@storage/auth';
import {
  readProjectsData,
  readProjectsSelectedProjectId,
} from '@storage/projects';

import { RootState } from '@store/types';
import { appDefaultState } from '@reducers/app';
import { uiDefaultState } from '@reducers/ui';

export const preloadStore = (): RootState => {
  // read from storage
  const authData = readAuthData();
  const { projects } = readProjectsData();
  const projectId = readProjectsSelectedProjectId();

  return {
    app: {
      ...appDefaultState,
      auth: {
        ...authDefaultState,
        isAuthorized: Boolean(authData),
      },
      projects: {
        ...projectsDefaultState,
        currentProjectWebApiUrl: getCurrentProjectWebApiUrlById(
          projectId ?? first(projects)?.id
        ),
        currentProjectAdminApiUrl: getCurrentProjectAdminApiUrlById(
          projectId ?? first(projects)?.id
        ),
        currentProject: projects
          ? findById(projects, projectId)
          : first(projects),
        projects: projects ?? [],
      },
    },
    ui: uiDefaultState,
  };
};
